/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface PopoverArgs {
  isOpen: boolean;
  onInsert: () => unknown;
  findAnchor: () => unknown;
  onMouseEnter: () => unknown;
  onMouseLeave: () => unknown;
}

export default class Popover extends Component<PopoverArgs> {}
